import { Defect, DefectPriority } from "../../types/defect";
import high from "../../assets/high.svg";
import medium from "../../assets/medium.svg";
import low from "../../assets/low.svg";

export const PriorityBody = (defect: Defect) => {
    let priority = defect.priority;
    let icon = high;

    if (priority === DefectPriority.Medium) {
        icon = medium;
    }

    if (priority === DefectPriority.Low) {
        icon = low;
    }
    
    return (
        <div className="flex justify-content-center">
            <img src={icon} className="priority-icon-size-small" alt={`priority-icon-${priority}`} />
        </div>
    );
};